// extracted by mini-css-extract-plugin
module.exports = {"root":"Images45_root__hRCM1","title":"Images45_title__1rPxc","images":"Images45_images__gguBa"};